module.exports = __webpack_public_path__ + "static/download_arrow-f2a86abc00a56dbe4a271ab06d2f6d6d.svg";